module.exports = __webpack_public_path__ + "img/logo.fddce5a3.png";